import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message, Form, DatePicker, Button, Row, Col, Radio } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "../../../utils/BasicAuthAPI";
import GanttChart from "./GanttChart";
import { indexOf } from "@amcharts/amcharts4/.internal/core/utils/Array";
import moment from "moment";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

const ParentGanttChart = (props) => {
  const chartRef = useRef(null);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [graphData, setGraphData] = useState({ data: null, loading: false });
  const [selectedDate, setSelectDate] = useState({
    from: moment().startOf("month").format("YYYY/MM/DD"),
    to: moment().endOf("month").format("YYYY/MM/DD"),
    type: "both",
  });
  const [loginError, setLoginError] = useState(false);

  const [items, setItems] = useState([]);
  const [form] = Form.useForm();
  props.setPageHeader("Training Gantt Chart");
  const onFinish = (values) => {
    if (values["To"].isAfter(values["From"])) {
      setSelectDate({
        from: values["From"].format("YYYY/MM/DD"),
        to: values["To"].format("YYYY/MM/DD"),
        type: values["Type"],
      });
    } else {
      message.error("'From date' can't be greater then 'To date'", 5);
    }
  };

  const fetchGraphData = () => {
    if (selectedDate.from !== null && selectedDate.to !== null) {
      setGraphData({ data: null, loading: true });
      
      liracrypt
        .get("/calendar/month", {
          from: selectedDate.from,
          to: selectedDate.to,
          typ: "TRG",
          page: "GanttChart",
          plAct: selectedDate["type"],
        })
        .then((res, req) => {
          let data = res.data;
          let newData = {};
          data.data.forEach((rec) => {
            const key = newData.hasOwnProperty(rec["itemid"])
              ? newData[rec["itemid"]]["currentItems"] + 1
              : 1;

            newData[rec["itemid"]] = newData[rec["itemid"]]
              ? newData[rec["itemid"]]
              : {};
            newData[rec["itemid"]]["itemid"] = rec["itemid"];
            newData[rec["itemid"]]["groupLabel"] = rec["groupLabel"];
            newData[rec["itemid"]]["series" + key + "TooltipLabel"] =
              rec["seriesTooltipLabel"];
            newData[rec["itemid"]]["series" + key + "FromDate"] = rec[
              "seriesFrom"
            ]
              ? moment(
                  rec["seriesFrom"] + " 00:00:00",
                  "YYYY/MM/DD HH:mm:ss"
                ).toDate()
              : null;
            newData[rec["itemid"]]["series" + key + "ToDate"] = rec["seriesTo"]
              ? moment(
                  rec["seriesTo"] + " 23:59:59",
                  "YYYY/MM/DD HH:mm:ss"
                ).toDate()
              : null;
            newData[rec["itemid"]]["series" + key + "Color"] =
              rec["seriesColor"];
            newData[rec["itemid"]]["currentItems"] = key;
          });
          const AllKeys = Object.keys(newData);
          const newDataList = AllKeys.map((k) => newData[k]);
          
          setGraphData({
            data: { ...data, newData: newDataList },
            loading: false,
          });
        })
        .catch(function (error) {
          setGraphData({ data: null, loading: false });
          console.log("Error****: fetch calendar", error);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
  };

  useEffect(() => {
    if (selectedDate.from !== null && selectedDate.to !== null) {
      
      form.setFieldsValue({
        From: moment(selectedDate.from, "YYYY/MM/DD"),
        To: moment(selectedDate.to, "YYYY/MM/DD"),
        Type: selectedDate.type,
      });
      fetchGraphData();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (items.length === 0) {
      // liracrypt
      //   .get("/trainingitems", {})
      //   .then((res, req) => {
      //     let data = res.data;
      //     const keys = Object.keys(data.data);
      //     let newData = [];
      //     keys.forEach((key) => {
      //       newData.push({ key: key, value: data.data[key] });
      //     });
      //     setItems(newData);
      //   })
      //   .catch(function (error) {
      //     console.log("Error****: fetch calendar", error);
      //     if (error.response !== undefined) {
      //       if (error.response.status !== 401) {
      //         ApiErrorComp(error.response.status);
      //       } else {
      //         setLoginError(true);
      //       }
      //     }
      //   });

      liracrypt
        .get("/mdict", { typ: "TrainingTypes", subTyp: "idame" })
        .then((res, req) => {
          let data = res.data;
          const keys = Object.keys(data.data);
          let newData = [];
          keys.forEach((key) => {
            newData.push({ key: key, value: data.data[key] });
          });
          setItems(newData);
        })
        .catch(function (error) {
          console.log("Error****: fetch calendar", error);
        });
    }
  }, [items]);

  // useEffect(() => {
  //     if (graphData === null) {
  //         axios.post('calendar/month', {
  //             "Typ": "TRG",
  //             "From": moment().format("YYYY/MM/DD"),
  //             "To": moment().format("YYYY/MM/DD"),
  //         }).then(({ data }) => {
  //             console.log(data);
  //             let newData = {};
  //             data.Data.forEach(rec => {

  //                 const key = newData.hasOwnProperty(rec["_id"]) ? newData[rec["_id"]]["currentItems"] + 1 : 1;

  //                 newData[rec["_id"]] = (newData[rec["_id"]]) ? newData[rec["_id"]] : {};
  //                 newData[rec["_id"]]["groupLabel"] = rec["groupLabel"];
  //                 newData[rec["_id"]]["series" + key + "TooltipLabel"] = rec["seriesTooltipLabel"];
  //                 newData[rec["_id"]]["series" + key + "FromDate"] = rec["seriesFrom"];
  //                 newData[rec["_id"]]["series" + key + "ToDate"] = rec["seriesTo"];
  //                 newData[rec["_id"]]["series" + key + "Color"] = rec["seriesColor"];
  //                 newData[rec["_id"]]["currentItems"] = key;
  //             });
  //             const AllKeys = Object.keys(newData);
  //             const newDataList = AllKeys.map(k => newData[k]);
  //             console.log(newDataList);
  //             setGraphData({ ...data, Data: newDataList });
  //             // console.log(dataEvent);
  //             // this.setState({
  //             //     currentEvents: [...this.state.currentEvents, ...dataEvent]
  //             // })
  //             // successCallback([...dataEvent])
  //         }).catch(function (error) {
  //             console.log("Error****: fetch calendar", error);
  //         });
  //     }
  // });

  return (
    <>
      <SessionError visible={loginError} />
      <div style={{ padding: "20px 10px" }}>
        <div
          className="GHeader"
          style={{ backgroundColor: "#27293d", padding: "0 0 5px" }}
        >
          <div className="ThemeForm">
            <Form
              form={form}
              name="evntForm"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 8 }}
              layout="horizontal"
              colon={false}
              onFinish={onFinish}
              size="large"
              wrapperCol={{ span: 20 }}
            >
              <Row gutter={24} justify="space-around">
                <Col span={14}>
                  <div
                    style={{
                      paddingLeft: "80px",
                      fontWeight: "bold",
                      fontSize: "22px",
                      color: "rgba(255, 255, 255, 0.65)",
                    }}
                  >
                    Period
                  </div>
                  <Form.Item
                    name="From"
                    label="From Date"
                    placeholder="Select From Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker placeholder="Select From Date" />
                  </Form.Item>
                  <Form.Item
                    name="To"
                    label="To Date"
                    placeholder="Select To Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker placeholder="Select To Date" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      color: "rgba(255, 255, 255, 0.65)",
                    }}
                  >
                    Type
                  </div>
                  <Form.Item
                    name="Type"
                    className={"inlineRadio"}
                    rules={[{ required: true }]}
                    label=""
                  >
                    <Radio.Group>
                      <Radio value={"plan"}>Plan</Radio>
                      <Radio value={"actual"}>Actual</Radio>
                      <Radio value={"both"}>Both</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 12 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button gx-mt-1 bigBtn"
                    >
                      {"Submit"}
                    </Button>
                  </Form.Item>
                </Col>
                {/* <Col span={24}>
                                <div className="formBtnGroupDiv" style={{ textAlign: "center" }}>
                                    <Button type="primary" htmlType="submit" className="login-form-button gx-mt-1 bigBtn">
                                        {"Submit"}
                                    </Button>
                                </div>
                            </Col> */}
              </Row>
            </Form>
          </div>
        </div>
        {graphData.data !== null ? (
          <div
            className="GanttChattHead"
            style={{
              backgroundColor: "#27293d",
              marginTop: "20px",
              padding: "20px 0",
            }}
          >
            <GanttChart
              data={graphData.data}
              refatchData={fetchGraphData}
              items={items}
            />
          </div>
        ) : graphData.loading ? (
          <div className="Loading">
            <Spin indicator={antIcon} tip="Loading..." />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ParentGanttChart;
